import {Injectable} from '@angular/core';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateFormatter {
  private SEPARATOR = '.';

  private getFallbackDate(): NgbDateStruct {
    const date = new Date();
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
  }


  parse(value: string): NgbDateStruct {
    if (!value) {
      return this.getFallbackDate();
    } else {
      const parts = value.split(this.SEPARATOR);
      return {year: +parts[0], month: +parts[1], day: +parts[2]} as NgbDateStruct;
    }
  }

  format(date: NgbDateStruct): string {
    if (!date) {
      date = this.getFallbackDate();
    }
    return ('0' + date.day).slice(-2) + this.SEPARATOR + ('0' + date.month).slice(-2) + this.SEPARATOR + date.year;
  }
}
